<template>
  <div>
    <template>
      <div class="flex timetable__title">
        <h2 class="timetable__mimk-name">{{selectedMimk.mimk_name}}</h2>
      </div>
      <Tags v-if="!isM1Schedule" entity-type="mimk" :entity-id="selectedMimk.mimk"></Tags>
      <span>{{newTimeStart}}</span>
      <span>{{newTimeEnd}}</span>
      <div class="timetable__week-change">
        <span class="timetable__week-toggler" @click="changeWeek()">{{$t('mc.supervisor.week.weeks.prev')}}</span>
        <h2 class="timetable__current-week">{{$t('mc.supervisor.week.weeks.current')}}: {{currentWeek}}</h2>
        <span class="timetable__week-toggler" @click="changeWeek(true)">{{$t('mc.supervisor.week.weeks.next')}}</span>
      </div>
        <div class="days-container">
          <div
            v-for="(day, indexDay) in days"
            :key="indexDay">
            <div :class="['day', {'day_eng': !isMilitaryTime}]">
              <div class="day__name">{{day.name_translated}}</div>
              <div class="day__iswork">
                <label class="switch">
                  <input type="checkbox" @click="switchToggle(!day.is_work, indexDay)" v-model="day.is_work">
                  <span class="slider round"></span>
                </label>
              </div>
              <div class="day-times" v-if="day.work_hours.length">
                <div :class="['day-time_box', {'shrink-box': !isMilitaryTime}, {'day-time_box--admin': time.is_admin_hours}]"
                  v-for="(time, indexTime) in day.work_hours"
                  :key="indexTime"
                  @click="changeExistTime(indexDay, day.date, indexTime, time)">
                  <span class="admin-type" v-if="time.is_admin_hours">{{ localesTypeOfHour[time.type_of_hours] }}</span>
                  {{time.work_starts_at}} – {{time.work_ends_at}}
                  <img
                    src="@/assets/svg/close.svg"
                    class="day-times__remove"
                    @click="removeTime(indexDay, indexTime)"
                  />
                </div>
              </div>
              <span
                v-html="$t('mc.supervisor.week.addHours')"
                :class="[{'day__add_opacity': !day.is_work},'day__add']"
                @click="addTime(indexDay, day.is_work, day.date)"/>
            </div>
          </div>
        </div>
    </template>
  </div>
</template>

<script>
import  militaryAndLanguage from "@/helpers/militaryAndLanguage"
import Tags from "./Tags"
export default {
  data() {
    return {
      militaryAndLanguage,
      days: {},
    }
  },
  components: {
    Tags,
  },
  props: {
    localesTypeOfHour: {
      type: Object,
    },
    newTimeStart: {
      type: String,
      required: false
    },
    newTimeEnd: {
      type: String,
      required: false
    },
    week: {
      type: Array,
      // required: true
    },
    selectedMimk: {
      type: Object,
      // required: true

    },
    currentWeekDays: {
      type: Object
    },
    isM1Schedule: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    isMilitaryTime() {
      let military = null
      military = this.militaryAndLanguage()
      return military
    },
    currentWeek() {
      return `${this.$dayjs(this.currentWeekDays.firstday).format('DD.MM')} - ${this.$dayjs(this.currentWeekDays.lastday).format('DD.MM.YYYY')}`
    }
  },
  mounted() {
    this.days = [...this.week]
    console.log(this.days);
    // Копируем из props в локальную переменную, чтобы можно было менять данные
    // Также удаляем из часов и минут дату
    let formatTime = this.isMilitaryTime ? 'HH:mm' : 'hh:mm a'
    this.days.forEach(element => {
      element.work_hours.length ? element.is_work = true : element.is_work = false
      for (let hours in element.work_hours) {
        let hour = element.work_hours[hours]
        // hour.work_ends_at = hour.work_ends_at.split(' ')[1]
        // hour.work_starts_at = hour.work_starts_at.split(' ')[1]
        hour.work_ends_at = this.isMilitaryTime ? hour.work_ends_at.split(' ')[1] : this.$dayjs(hour.work_ends_at.split(' ')[1], 'HH:mm').format(formatTime)
        hour.work_starts_at = this.isMilitaryTime ? hour.work_starts_at.split(' ')[1] : this.$dayjs(hour.work_starts_at.split(' ')[1], 'HH:mm').format(formatTime)
      }
    })
  },
  methods: {
    changeExistTime(indexDay, date, indexTime, time) {
      this.emitUpdateWeek(indexDay, date, indexTime, time)
    },
    //При переключение свитча, если ставим его в положение false, то чистим все рабочие часы в массиве
    switchToggle(isWork, indexDay) {
      if (!isWork) {
        if (!this.days[indexDay].work_hours.length) return
        this.days[indexDay].work_hours = []
        this.days[indexDay].is_work = false
        this.$emit('removeItem', this.days)
      }
    },
    changeWeek(isNext) {
      //Эмит при переключении дня недели
      this.$emit('changeWeek', isNext)
    },
    emitUpdateWeek(indexDay, date, indexTime, time) {
      let emitsObject = {
        indexDay,
        date
      }
      if (time) {
        emitsObject.indexTime = indexTime
        emitsObject.time = time
      }
      //Отправляем эмит с аргументами  индекса и даты рабочего дня.
      this.$emit('updateWeek', emitsObject)
    },
    addTime(indexDay, isWork, date) {
      if (isWork) this.emitUpdateWeek(indexDay, date)
    },
    removeTime(indexDay, indexTime) {
      this.days[indexDay].work_hours.splice(indexTime, 1)
      if (this.days[indexDay].work_hours.length === 0) {
        this.days[indexDay].is_work = false
      }
      this.$emit('removeItem', this.days)
    },
  },
}
</script>

<style lang="scss" scoped>
.timetable {
    &__title {
      justify-content: space-between;
      margin-bottom: 50px;
    }
    &__week-change {
      margin-bottom: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
  }
  &__current-week {
    font-weight: 700;
  }
  &__week-toggler {
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    color: #315AF2;
  }
}

// .days-container {
//   max-width: 650px;
//   margin: auto;
// }
.day {
  margin-bottom: 24px;
  display: grid;
  align-items: center;
  grid-template-columns: 140px 50px 286px 130px;
  column-gap: 20px;
  margin-bottom: 20px;
  &_eng {
    grid-template-columns: 140px 50px 386px 130px;
  }
  &-time_box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 18px;
    max-width: 134px;
    min-width: 134px;
    padding: 12px 0;
    font-size: 14px;
    border: 1px solid #315AF2;
    cursor: pointer;
    border-radius: 4px;
    color: #315AF2;
    font-family: 'Open Sans', sans-serif;
    margin-bottom: 5px;
    &:last-child {
      margin-right: 0;
    }
    &--admin {
      color: #373C4A;
      border-color: #373C4A;
      position: relative;
      padding: 12px 0 7px;
      .admin-type {
        position: absolute;
        font-size: 10px;
        top: 0;
        left: 12px;
      }
    }
  }
  &__name {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
  }
  &__add {
    cursor: pointer;
    font-weight: 500;
    font-size: 12px;
    color: #315AF2;
  &_opacity {
    color: #BEBEBE;
  }
  }
  &-times {
    display: grid;
    grid-template-columns: 1fr 1fr;
    &-element {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
    }
    &__remove {
      width: 8px;
      height: 8px;
      margin-left: 15px;
    }
  }
  &-subtime {
    display: grid;
    align-items: center;
    grid-template-columns: 260px repeat(2, 100px) 200px;
    column-gap: 10px;
    margin-bottom: 20px;
    &-remove {
      text-align: left;
      &__icon {
        width: 10px;
      }
    }
  }
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E8E8EA;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #315AF2;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 3px;
}

// .slider.round:before {
//   border-radius: 50%;
// }

.shrink-box {
  min-width: 180px;
  max-width: 180px;
}
</style>
